import { React, useEffect, useState } from "react";
import "../../styles/desktop/eventos.css";
import Detalhes from "./detalhes/detalhes";
import Chamados from "./chamados/chamados";

const Eventos = ({ filtro, eventos, loading, getData }) => {
  const [filteredEventos, setFilteredEventos] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState("Todos");
  const [filtroDataInicio, setFiltroDataInicio] = useState("");
  const [filtroDataFim, setFiltroDataFim] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroIP, setFiltroIP] = useState("");
  const [filtroStatusAlarme, setFiltroStatusAlarme] = useState(filtro || "Todos");
  const [selectedEvento, setSelectedEvento] = useState(null);
  const [opcoesStatus, setOpcoesStatus] = useState([]);

  useEffect(() => {
    let opcoes = ["Todos", filtro, "Concluído", "Pendente", "Em Andamento", "Concluído/Pendente", "Ocorrência"];
    const opcoesUnicas = ["Todos", ...new Set(opcoes.filter(opcao => opcao !== "Todos"))];
    setOpcoesStatus(opcoesUnicas);
  }, [filtro]);

  useEffect(() => {
    setFiltroStatusAlarme(filtro);
  }, [filtro]);


  const handleFilter = () => {
    if (!eventos || eventos.length === 0) return;
  
    const filtered = eventos.filter((evento) => {
      const [dia, mes, ano] = evento.data.split("/");
      const eventoData = new Date(`${ano}-${mes}-${dia} ${evento.hora}`);
  
      const dataInicioMatches = !filtroDataInicio || eventoData >= new Date(filtroDataInicio);
      const dataFimMatches = !filtroDataFim || eventoData <= new Date(filtroDataFim);
      const tipoMatches = filtroTipo === "Todos" || evento.tipo === filtroTipo;
      const nomeMatches = !filtroNome || evento.nome.toLowerCase().includes(filtroNome.toLowerCase());
      const ipMatches = !filtroIP || evento.ip.includes(filtroIP);
      const statusAlarmeMatches = filtroStatusAlarme === "Todos" || evento.chamado_status?.toLowerCase() === filtroStatusAlarme.toLowerCase();
  
      return dataInicioMatches && dataFimMatches && tipoMatches && nomeMatches && ipMatches && statusAlarmeMatches;
    });
  
    // Ordena do mais recente para o mais antigo
    const sortedFiltered = filtered.sort((a, b) => {
      const [diaA, mesA, anoA] = a.data.split("/");
      const [diaB, mesB, anoB] = b.data.split("/");
      
      const dataHoraA = new Date(`${anoA}-${mesA}-${diaA} ${a.hora}`);
      const dataHoraB = new Date(`${anoB}-${mesB}-${diaB} ${b.hora}`);
  
      return dataHoraB - dataHoraA; // Ordenação decrescente (do mais recente para o mais antigo)
    });
  
    setFilteredEventos(sortedFiltered);
  };
  
  useEffect(() => {
    handleFilter(); // eslint-disable-next-line
  }, [filtroTipo, filtroDataInicio, filtroDataFim, filtroNome, filtroIP, filtroStatusAlarme, eventos]); 

  const handleOpenChamados = (evento) => {
    if (evento.chamado_status === "Ocorrência") {
      setSelectedEvento({ tipo: "detalhes", evento });
    } else {
      setSelectedEvento({ tipo: "chamados", evento });
    }
  };

  const handleCloseChamados = () => {
    setSelectedEvento(null);
  };

  const handleClearFilters = () => {
    setFiltroTipo("Todos");
    setFiltroDataInicio("");
    setFiltroDataFim("");
    setFiltroNome("");
    setFiltroIP("");
    setFiltroStatusAlarme("Todos");
    handleFilter();
  };

  return (
    <div className="ContainerHistory">
      <h1 className="tituloHistory">Registros de eventos</h1>

      {/* Filtros */}
      <div className="ContainerFiltro">
        <div className="filterRow">
          <div className="filterGroup">
            <label htmlFor="filtroTipo">Tipo:</label>
            <select
              id="filtroTipo"
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
            >
              <option value="Todos">Todos</option>
              <option value="Dispositivos">Dispositivos</option>
              <option value="Agendamentos">Agendamentos</option>
              <option value="Alarme">Alarmes</option>
              <option value="Notificações">Notificações</option>
            </select>
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroDataInicio">Data de início:</label>
            <input
              type="date"
              id="filtroDataInicio"
              value={filtroDataInicio}
              onChange={(e) => setFiltroDataInicio(e.target.value)}
            />
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroDataFim">Data de fim:</label>
            <input
              type="date"
              id="filtroDataFim"
              value={filtroDataFim}
              onChange={(e) => setFiltroDataFim(e.target.value)}
            />
          </div>
        </div>

        <div className="filterRow">
          <div className="filterGroup">
            <label htmlFor="filtroNome">Nome do Dispositivo:</label>
            <input
              type="text"
              id="filtroNome"
              value={filtroNome}
              onChange={(e) => setFiltroNome(e.target.value)}
            />
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroIP">IP do Dispositivo:</label>
            <input
              type="text"
              id="filtroIP"
              value={filtroIP}
              onChange={(e) => setFiltroIP(e.target.value)}
            />
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroStatusAlarme">Status do evento:</label>
            <select
              id="filtroStatusAlarme"
              value={filtroStatusAlarme}
              onChange={(e) => setFiltroStatusAlarme(e.target.value)}
            >
              {opcoesStatus.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="buttonRow">
          <button className="btnFiltrar" onClick={handleClearFilters}>Padrão</button>
        </div>
      </div>

      {/* Tabela */}
      <div className={`ContainerTabela ${loading ? "shimmer" : ""}`}>
        {!loading && filteredEventos.length === 0 ? (
          <p className="noRecordsMessage">Nenhum registro foi encontrado</p>
        ) : (
          !loading && (
            <table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Tipo</th>
                  <th>Descrição</th>
                  <th>IP Controlador</th>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredEventos.map((evento, index) => (
                  <tr
                    key={index}
                    onClick={() => handleOpenChamados(evento)}
                    className={evento.tipo === "Alarme" && evento.status === "false" ? "alarme-false" : ""}
                  >
                    <td>{evento.nome}</td>
                    <td>{evento.tipo}</td>
                    <td>{evento.descricao}</td>
                    <td>{evento.ip}</td>
                    <td>{evento.data}</td>
                    <td>{evento.hora}</td>
                    <td>{evento.chamado_status || "Nenhum chamado associado"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </div>

      {/* Chamados e Detalhes */}
      {selectedEvento && selectedEvento.tipo === "chamados" && (
        <Chamados evento={selectedEvento.evento} onClose={handleCloseChamados} getData={getData} />
      )}
      {selectedEvento && selectedEvento.tipo === "detalhes" && (
        <Detalhes evento={selectedEvento.evento} onClose={handleCloseChamados} />
      )}
    </div>
  );
};

export default Eventos;
